import { UserGetOut } from '../types';

export enum TestUsers {
  NewUser = 'newUser',
  BloodTestUser = 'bloodTestUser',
  DNATestUser = 'dnaTestUser',
  HormoneTestUser = 'hormoneTestUser',
  TestOnlyUser = 'testOnlyUser',
  VitaminsOnlyUser = 'vitaminsOnlyUser',
  AllProductsUser = 'allProductsUser',
}

export const userData: Record<TestUsers | string, UserGetOut> = {
  newUser: {
    id: '1',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'newuser@rootine.co',
    name: 'New User',
    blood_result: false,
    dna_result: false,
    dna_status: '',
    customer_status: '',
    customer_type: '',
    first_name: 'New',
    last_name: 'User',
    subscription_status: '',
    vitamin_test_status: '',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: '',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: false,
    wearable_source_id: '',
  },
  bloodTestUser: {
    id: '2',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'bloodtest@rootine.co',
    name: 'Blood Test Only',
    blood_result: true,
    dna_result: false,
    dna_status: '',
    customer_status: 'active',
    customer_type: '',
    first_name: 'Blood Test Only',
    last_name: 'User',
    subscription_status: 'test_only',
    vitamin_test_status: 'available',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: '',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: false,
    wearable_source_id: '',
  },
  dnaTestUser: {
    id: '1',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'newuser@gmail.com',
    name: 'DNA Only User',
    blood_result: false,
    dna_result: true,
    dna_status: 'available',
    customer_status: 'active',
    customer_type: '',
    first_name: 'DNA Only',
    last_name: 'User',
    subscription_status: '',
    vitamin_test_status: '',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: '',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: true,
    wearable_source_id: '',
  },
  allProductsUser: {
    id: '1',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'newuser@gmail.com',
    name: 'All products user',
    blood_result: true,
    dna_result: true,
    dna_status: 'available',
    customer_status: 'active',
    customer_type: '',
    first_name: 'All products',
    last_name: 'User',
    subscription_status: 'active',
    vitamin_test_status: 'available',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: 'available',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: true,
    wearable_source_id: '',
  },
  testOnlyUser: {
    id: '1',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'testuser@gmail.com',
    name: 'Test Only User',
    blood_result: true,
    dna_result: true,
    dna_status: 'available',
    customer_status: 'active',
    customer_type: '',
    first_name: 'Test Only',
    last_name: 'User',
    subscription_status: '',
    vitamin_test_status: 'available',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: '',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: false,
    wearable_source_id: '',
  },
  vitaminsOnlyUser: {
    id: '5',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'vitaminuser@rootine.co',
    name: 'Vitamin Only User',
    blood_result: false,
    dna_result: false,
    dna_status: '',
    customer_status: 'active',
    customer_type: '',
    first_name: 'Vitamin Only',
    last_name: 'User',
    subscription_status: 'active',
    vitamin_test_status: '',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: '',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: false,
    wearable_source_id: '',
  },
  hormoneTestUser: {
    id: '6',
    ship_street1: '',
    ship_street2: '',
    ship_city: '',
    ship_state: '',
    ship_zip: '',
    email: 'hormoneTestUser@rootine.co',
    name: 'Horemone Test User',
    blood_result: false,
    dna_result: false,
    dna_status: '',
    customer_status: 'active',
    customer_type: '',
    first_name: 'Vitamin Only',
    last_name: 'User',
    subscription_status: 'active',
    vitamin_test_status: '',
    vitamins_in_shipping: false,
    dnatest_report: '',
    omega3_status: '',
    hormone_status: 'available',
    phone: '',
    hormone_subscription_status: '',
    is_dna_section_available: false,
    wearable_source_id: '',
  },
};
